import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-148" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-149" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-150" data-mp="3fy2z7vpm7s3i">
          What cardiology students are saying
        </h2>
        <div className="mt-2 space-y-2" data-id="element-151" data-mp="36z9469rxn9s2">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 bg-ice px-2.5 py-2" data-id="element-152" data-mp="31zd2ih6pjufo">
              <div className="flex gap-0.5 text-[#E0A526]" role="img" aria-label="5 out of 5 stars" data-id="element-153" data-mp="2x09vwsb2xg5l">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-154" data-mp="2s3ta44rcrdvo" data-mpi={i} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] leading-[1.4] sm:text-[0.9rem]" data-id="element-155" data-mp="qaljhz6ah9uh">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-156" data-mp="h5ezpnh15z1q">
                <span className="font-extrabold text-navy" data-id="element-157" data-mp="m4rjfzcluq03">{t.name}</span>
                <span className="text-ink/75" data-id="element-158" data-mp="m2onkyoru2ng">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}